import "rxjs/add/observable/fromPromise";
import "rxjs/add/observable/of";
import "rxjs/add/operator/combineAll";
import {Subscription} from "rxjs/Subscription";
import {take, filter} from "rxjs/operators";
import _ from "lodash";
import $ from 'jquery';
import moment from "moment";

import module from "module";

export const isReleasedOrClosed = (pawn) => pawn && ['ACTIVE', 'MATURE', 'PAST_DUE_PERFORMING', 'PAST_DUE_NON_PERFORMING', 'AUCTIONED', 'STOCKED', 'PAST_DUE_WRITE_OFF', 'CLOSED'].includes(pawn.status);

const templateUrl = require('./customer-pawns.template.html');
module.component('customerPawns', {
  templateUrl: templateUrl,
  controller: function ($route, $routeParams, $location, $scope, http, customerCache, confirmation, notification,
                        userCache, nav, pawnStatusMapper, pawnProductsCache, $filter, pawnItemTypeCache, pawnMetalRateCache,
                        branchService, authentication, branchWorkingDayCache, dashboardActionService, confirmationTemplate,
                        command, queryParamsRemover, customerService, pawnTagCache, pawnItemCache, popup, pawnAuctionCache,
                        systemPropertyCache, operationService) {
    let that = this;

    $scope.permission = authentication.permissions;

    const closedPawnStatuses = ['CLOSED', 'CANCELED'];
    that.hideClosed = $routeParams.hideClosed === "true";
    that.visiblePawns = [];

    that.pawnStatusMapper = pawnStatusMapper;
    that.workingDay = null;
    that.contextBranchId = authentication.context.branchId;
    that.pawns = [];

    let customerId = $route.current.params['customerId'];
    let pawnId = $route.current.params['pawnId'];

    $scope.$watch('$ctrl.selectedPawn', async () => {
      if (!that.selectedPawn) {
        return false;
      }

      const workingDay = await branchWorkingDayCache.withParam(that.selectedPawn.branchId).toPromise();
      const response = await operationService.fetchOperations({
        productId: that.selectedPawn.id,
        group: ['WAIVE_PENALTY', 'WAIVE_PAST_DUE_INTEREST'],
        dateFrom: moment(workingDay.postingDate).format('YYYY-MM-DD'),
        dateTo: moment(workingDay.postingDate).format('YYYY-MM-DD')
      });

      const todayWaiveOperations = _.sortBy(response.result, 'processedOn').reverse();
      that.todayLastWaiveOperation = _.first(todayWaiveOperations);
    });

    queryParamsRemover.removeQueryOnRedirect($scope, ['hideClosed']);

    that.togglePawns = () => {
      if (that.hideClosed) {
        that.visiblePawns = that.pawns.filter(pawn => pawn.status !== 'CLOSED');
      } else {
        that.visiblePawns = that.pawns;
      }

      if (that.selectedPawn) {
        $location
          .path(`/customer/${customerId}/pawns/${that.selectedPawn.id}`)
          .search('hideClosed', that.hideClosed.toString());
      }
    };

    const isPawnClosed = (pawnId) => {
      const pawn = _.find(that.pawns, {id: pawnId});
      return pawn && _.includes(closedPawnStatuses, pawn.status);
    };

    const isWithdrawnAndPermittedToSee = (pawn) => pawn.status === 'PAST_DUE_WRITE_OFF' && authentication.permissions['MNG_PWN_WITHDRAWN_READ'];

    // This method is called from 2 places due to how 'tags' and 'selectedPawn' are resolved
    // Either there are no 'tags' once 'selectedPawn' is initialized or the other way, needs nice refactor
    const assignTagName = (pawn, tags) => {
      if (!_.isEmpty(pawn)) {
        pawn.tag = _.first(_.filter(tags, t => t.id === pawn.tagId).map(t => t.name));
      }
    };

    const s = systemPropertyCache.toObservable()
      .combineLatest(customerCache.pawns(customerId).toObservable(), (systemProperties, pawns) => {
        const headOfficeId = _.find(systemProperties, {code: 'HEAD_OFFICE_BRANCH_ID'}).value;
        that.headOfficeId = Number(headOfficeId);
        const showMessageOnPawnRenewalInAnotherBranch = _.find(systemProperties, {code: 'SHOW_MESSAGE_ON_PAWN_RENEWAL_IN_ANOTHER_BRANCH'});
        this.showMessageOnPawnRenewalInAnotherBranch = showMessageOnPawnRenewalInAnotherBranch && showMessageOnPawnRenewalInAnotherBranch.value === 'TRUE';
        const allowRedemptionOnWithdrawnPawn = _.find(systemProperties, {code: 'ALLOW_REDEMPTION_ON_WITHDRAWN_PAWN'});
        this.allowRedemptionOnWithdrawnPawn = allowRedemptionOnWithdrawnPawn && allowRedemptionOnWithdrawnPawn.value === 'TRUE';
        const auctionTaggingProperty = _.find(systemProperties, {code: 'AUCTION_TAGGING_ENABLED'});
        this.isAuctionTaggingEnabled = auctionTaggingProperty && auctionTaggingProperty.value === 'TRUE';

        return pawns;
      }).combineLatest(pawnProductsCache.toObservable(), (pawns, pawnTypes) => {
        if (!pawns || !Array.isArray(pawns)) return [];

        return pawns.map(pawn => {
          // add pawnProduct to pawn object
          const type = _.find(pawnTypes, {id: pawn.typeId});
          return Object.assign(pawn, {
            pawnType: type
          });
        })
      })
      .combineLatest(pawnAuctionCache.systemAuctions().toObservable(), (pawns, auctions) => {
        if (!pawns || !Array.isArray(pawns)) return [];

        for (let pawn of pawns) {
          if (pawn.auctionId == null) {
            continue;
          }

          let auction = _.find(auctions, {id: pawn.auctionId});
          if (auction != null && auction.conditionType === 'EXPIRATION_DATE') {
            let momentDateFormat = 'YYYY-MM-DD';
            pawn.auctionedOnDate = moment(pawn.expirationDate, momentDateFormat)
              .add(1, 'day')
              .format(momentDateFormat);
          }
        }
        return pawns;
      })
      .combineLatest(branchService.toObservable(), (pawns, branches) => {
        if (!pawns || !Array.isArray(pawns)) return [];

        return pawns.map(pawn => Object.assign(pawn, {branch: _.find(branches, {id: pawn.branchId})}));
      })
      .combineLatest(userCache.toObservable(), (pawns, users) => {
        if (!pawns || !Array.isArray(pawns)) return [];

        return pawns.map(pawn => Object.assign(pawn, {
          user: _.find(users, {id: pawn.userId}),
          appraisalUser: _.find(users, {id: pawn.appraisalUserId})
        }))
      })
      .subscribe(allPawns => {

        let pawns;
          // Select only pawns available for users
          const branchIds = authentication.context.branchIds;

          if (this.isAuctionTaggingEnabled) {
            pawns = _.filter(allPawns, p => p.status !== 'PAST_DUE_WRITE_OFF' || isWithdrawnAndPermittedToSee(p));
          } else {
            pawns = _.filter(allPawns, p => _.includes(branchIds, p.branchId) || isWithdrawnAndPermittedToSee(p));
          }

          // select first account when none selected
          if (!pawnId && pawns.length > 0) $location.path(`/customer/${customerId}/pawns/${pawns[0].id}`);

          if (pawnId) {
            const pawn = _.find(pawns, (a) => String(a.id) === pawnId);
            if (pawn) {
              that.selectedPawn = pawn;
            } else {
              $location.path(`/customer/${customerId}/pawns`);
            }
          }

          that.pawns = pawns.map(p => {
            // Calculate total outstanding
            p.totalOutstandingBalance = p.principalBalance + p.interestBalance + p.pastDueInterestBalance + p.penaltyBalance;
            // Find parent pawn (only if parent pawn is owned by the same user)
            if (p.parentPawnId) {
              const parentPawn = _.find(pawns, {id: p.parentPawnId});
              p.parentPawnNumber = parentPawn ? parentPawn.productNumber : 'N/A';
            }
            // Find root pawn (only if root pawn is owned by the same user)
            if (p.rootPawnId) {
              const rootPawn = _.find(pawns, {id: p.rootPawnId});
              p.rootPawnNumber = rootPawn ? rootPawn.productNumber : 'N/A';
            }

            return p;
          });

          if (that.hideClosed) {
            that.visiblePawns = that.pawns.filter(pawn => pawn.status !== 'CLOSED');

            if (that.selectedPawn && that.selectedPawn.status === 'CLOSED' && that.selectPawn && that.visiblePawns[0]) {
              that.selectPawn(that.visiblePawns[0]);
            }
          } else {
            that.visiblePawns = that.pawns;
          }

          assignTagName(that.selectedPawn, that.tags);
        }
      );

    that.refreshPawnsAndReload = async () => {
      try {
        customerCache.pawns(customerId).refetch();

        // Wait for the observable to emit fresh data
        await customerCache.pawns(customerId).toObservable()
          .pipe(
            filter(pawns => pawns && Array.isArray(pawns)),
            take(1) // Take the first new emission
          ).toPromise();

        $route.reload();
      } catch (error) {
        console.error('Failed to refresh: ', error);
        $route.reload(); // Fallback
      }
    }

    let s2 = pawnItemTypeCache.toObservable().subscribe(types => {
      that.typeMap = {};
      for (let t of types) {
        that.typeMap[t.id] = t.name;
      }
    });

    let s3 = pawnMetalRateCache.toObservable().subscribe(metals => {
      that.metalMap = {};
      for (let m of metals) {
        that.metalMap[m.id] = m.fineness;
      }
    });

    let s4 = branchWorkingDayCache.withParam(that.contextBranchId).toObservable().subscribe(workingDay => {
      that.workingDay = workingDay;
    });

    that.mapDefectLevel = (defectLevel) => {
      if (defectLevel === 'NONE') return 'Good';
      return $filter('prettyEnum')(defectLevel);
    };

    const subscription = new Subscription();
    subscription.add(s);
    subscription.add(s2);
    subscription.add(s3);
    subscription.add(s4);

    that.transactionClicked = (transaction, $event) => {
      $event.stopPropagation();
      that.selectedTransaction = transaction.id;
    };

    that.hideInlinePanel = () => {
      that.selectedTransaction = null;
    };

    that.selectpawn = (pawn) => {
      that.pawnApprovalTask = null;
      that.selectedPawn = pawn;
      $location.path(`/customer/${customerId}/pawns/${pawn.id}`);
    };

    that.numberOfPawnedItems = (pawn) => pawn ? _.filter(pawn.items, i => (i.status == 'PAWNED_ACTIVE' || i.status == 'PAWNED_EXPIRED')).length : 0;

    that.$onInit = async () => {
      const profile = await customerCache.profile(customerId).toPromise();
      await customerService.redirectWhenProfileIsInvalid(profile);
      that.tags = await pawnTagCache.toPromise();
      assignTagName(that.selectedPawn, that.tags);
    };

    that.$onDestroy = () => {
      subscription.unsubscribe();
    };

    that.createNew = () => nav.setSource('customer-pawns') && $location.path(`/customer/${customerId}/pawns/create`);
    that.withdrawForAuction = () => $location.path(`/customer/${customerId}/pawns/${that.selectedPawn.id}/withdraw`);
    that.releaseByCash = () => $location.path(`/customer/${customerId}/pawns/${that.selectedPawn.id}/release/cash`);
    that.redeem = () => $location.path(`/customer/${customerId}/pawns/${that.selectedPawn.id}/redeem`);
    that.renew = () => $location.path(`/customer/${customerId}/pawns/${that.selectedPawn.id}/renew`);
    that.renewWithExtraCash = () => $location.path(`/customer/${customerId}/pawns/${that.selectedPawn.id}/loan-addition`);
    that.waive = () => $location.path(`/customer/${customerId}/pawns/${that.selectedPawn.id}/waive`);
    that.partialRenewal = () => $location.path(`/customer/${customerId}/pawns/${that.selectedPawn.id}/renew-partial`);
    that.changeOwner = () => $location.path(`/customer/${customerId}/pawns/${that.selectedPawn.id}/change-owner`);
    that.partialRedemption = () => $location.path(`/customer/${customerId}/pawns/${that.selectedPawn.id}/redemption-partial`);
    that.ptPreview = () => $location.path(`/customer/${customerId}/pawns/${that.selectedPawn.id}/ticket`);
    that.renewalTicket = () => $location.path(`/customer/${customerId}/pawns/${that.selectedPawn.id}/pawn-renewal-ticket`);
    that.updatePawn = () => $location.path(`/customer/${customerId}/pawns/${that.selectedPawn.id}/update`);
    that.updatePawnItems = () => $location.path(`/customer/${customerId}/pawns/${that.selectedPawn.id}/update-items`);

    that.sendForApproval = () => confirmation('Do you want to send the pawn for approval?', () =>
      http.post(`/products/pawns/${that.selectedPawn.id}/send-for-approval`).success(async () => {
        notification.show("Pawn has been sent for approval");
        await that.refreshPawnsAndReload();
      }).error((data) => {
        showError(data, 'Send for approval');
      })
    );

    that.approve = ($event) => {
      if ($event) $event.stopPropagation();
      // Refetch task associated with given pawn
      const pawnId = that.selectedPawn.id;
      http.get(`/tasks?taskGroup=PAWN_APPROVAL&objectId=${pawnId}`).success(async (task) => {
        // If task associated with pawn is not PENDING -> refetch pawns
        if (task.approvalStatus === 'PENDING') {
          that.pawnApprovalTask = task;
        } else {
          await that.refreshPawnsAndReload();
        }
      }).error((data) => {
        showError(data, 'Approve');
      })
    };

    that.approvalPinEntered = (task, pin, user) => dashboardActionService.pinEntered(task, pin, user, async (task) => {
      await that.refreshPawnsAndReload();
    });

    that.cancelPawn = () => confirmation('Do you want to cancel the pawn?', () =>
      http.doDelete(`/products/pawns/${that.selectedPawn.id}/cancel`).success(async () => {
        notification.show("Pawn has been canceled");
        await that.refreshPawnsAndReload();
      }).error((data) => {
        showError(data, 'Cancel');
      })
    );

    function showError(data, actionName) {
      const details = data.errorMessage ? data.errorMessage : "An unknown error occurred.";
      let message = `<strong>Error executing:&nbsp;</strong>'${actionName}'.`;

      if (details) message += `<br><br><strong>Details:&nbsp;</strong>${details}`;
      popup({text: message, renderHtml: true});
    }

    that.reopenRedeemedPawn = () => {
      confirmationTemplate({
        question: `Do you want to reopen the pawn ${that.selectedPawn.productNumber}?`,
        details: [
          {label: 'Principal amount', description: $filter('php')(that.selectedPawn.principalAmount)},
          {label: 'Interest amount', description: $filter('php')(that.selectedPawn.interestAmount)},
          {label: 'Past due interest amount', description: $filter('php')(that.selectedPawn.pastDueInterestAmount)},
          {label: 'Penalty amount', description: $filter('php')(that.selectedPawn.penaltyAmount)},
          {label: 'Release amount', description: $filter('php')(that.selectedPawn.releaseAmount)},
          {label: 'Maturity date', description: $filter('prettyDate')(that.selectedPawn.maturityDate)}
        ],
        warning: 'This operation cannot be reverted safely.<br>Please make sure that the pawn you selected is correct.',
        yesCallback: () => command.execute('ReopenRedeemedPawn', {
          productId: that.selectedPawn.id
        }).success(async () => {
          notification.show("Pawn has been reopened");
          await that.refreshPawnsAndReload();
        })
      });
    };

    that.revertWithdrawPawn = async (item) => {
      const confirmed = await confirmation('Do you want to revert withdrawal of this pawn?');
      if (!confirmed) {
        return;
      }

      await command.execute("RollbackWithdrawPawn", {productId : item.id}).toPromise();
      await that.refreshPawnsAndReload();
      $route.reload();
    }

    that.deletePawn = () => {
      let parent = that.selectedPawn.parentPawnId
        ? `<br>The following pawn will be reopened: <strong>${that.selectedPawn.parentPawnNumber}</strong>`
        : '';

      confirmation(`
      Do you want to delete the pawn?
      ${parent}
      <br><br><strong class="red">WARNING: Please be advised that this operation is irreversible.</strong>
      `, () => command.execute('DeletePawn', {
          productId: that.selectedPawn.id
        }).success(async () => {
          notification.show("Pawn has been deleted");
          await that.refreshPawnsAndReload();
        }), () => {
        }, true
      );
    };

    that.isReleasedOrClosed = (pawn) => isReleasedOrClosed(pawn);

    /**
    * Determines if a pawn is actionable based on its status and the user's branch access.
    * This ensures that pawns from branches the user has no access to remain read-only.
    */
    that.isReleasedActiveAndAccessible = (pawn) =>
      pawn && (pawn.status === 'ACTIVE'
        || pawn.status === 'MATURE'
        || pawn.status === 'PAST_DUE_PERFORMING'
        || pawn.status === 'PAST_DUE_NON_PERFORMING'
      ) && _.includes(authentication.context.branchIds, pawn.branchId);

    that.isWithdrawn = (pawn) => pawn && pawn.status === 'PAST_DUE_WRITE_OFF';

    that.isWaiveDisabled = (pawn) => {
      return !pawn || !pawn.penaltyBalance && !pawn.pastDueInterestBalance
    }

    that.isWaiveAvailable = (pawn) => {
      if (!pawn) {
        return false;
      }

      // CE-770: waive/revert are authorized by branch-access membership (backend), not by the
      // currently active branch. isReleasedActiveAndAccessible already checks branch access, so
      // do not additionally require the pawn's branch to be the active one.
      if (!that.isReleasedActiveAndAccessible(pawn)) {
        return false;
      }

      return !that.todayLastWaiveOperation || ['REVERTED', 'REJECTED'].includes(that.todayLastWaiveOperation.status);
    }

    that.isRevertWaiveAvailable = (pawn) => {
      if (!pawn) {
        return false;
      }
      // CE-770: waive/revert are authorized by branch-access membership (backend), not by the
      // currently active branch. isReleasedActiveAndAccessible already checks branch access, so
      // do not additionally require the pawn's branch to be the active one.
      if (!that.isReleasedActiveAndAccessible(pawn)) {
        return false;
      }
      if (that.isWaiveAvailable(pawn)) {
        return false;
      }
      return that.todayLastWaiveOperation && that.todayLastWaiveOperation.status === 'PROCESSED';
    }

    that.revertWaivePawn = async () => {
      const confirmed = await confirmation('Do you want to revert waive?');
      if (!confirmed) {
        return;
      }

      await command.execute('WaivePawnRevert', {commandId: that.todayLastWaiveOperation.commandId}).toPromise();
      await that.refreshPawnsAndReload();
      $route.reload();
    }

    that.isReopenRedeemedAvailable = (pawn) => pawn && pawn.status && pawn.status === 'CLOSED';

    that.isHeadOffice = () => that.headOfficeId === that.contextBranchId;

    that.isRedemptionAvailable = (pawn) => {
      if (!pawn) {
        return false;
      }
      if (that.allowRedemptionOnWithdrawnPawn) {
        if (isWithdrawnAndPermittedToSee(pawn) && that.isHeadOffice()) {
          // 1. withdrawn
          // 2. has read withdrawn pawn permission (Admin role)
          // 3. is head office
          // In summary, only Head Office Admin can redeem withdrawn pawn (Head Office Admin)
          return true;
        }
        if (that.isWithdrawn(pawn)) {
          // 1. withdrawn
          // 2.a has no permission (Non-admin role) and is head office  (Head Office Non-admin)
          // 2.b has permission (Admin role) and non-head office        (Non-head office Admin)
          // 2.c has no permission (Non-admin role) and non-head office (Non-head office Non-admin)
          return false;
        }
      }
      return that.isReleasedActiveAndAccessible(pawn) && that.isSelectedPawnRegisteredOrOriginalBranch(pawn);
    }

    that.isDeleteAvailable = (pawn) => pawn && pawn.status && !_.includes(['CLOSED', 'CANCELED'], pawn.status);

    that.isRevertWithdrawAvailable = (pawn) => that.isWithdrawn(pawn)
      && that.isSelectedPawnRegisteredBranch(pawn);

    that.isSelectedPawnAuctioned = (pawn) => pawn && pawn.status && pawn.status === 'AUCTIONED';

    that.gotoPawn = (pawnId) => {

      // Check if pawn is hidden
      if (isPawnClosed(pawnId)) {
        $location.path(`/customer/${customerId}/pawns/${pawnId}`).search({displayClosed: 1});
        return;
      }

      // scroll to pawn
      const pawnRow = $(`#pawn_${pawnId}`);
      if (!pawnRow) {
        console.error('No pawn tag defined for pawnId: ', pawnId);
      } else {
        if (!isScrolledIntoView(pawnRow)) {
          const pawnYCoordinate = pawnRow.offset().top;
          $("html, body").animate({scrollTop: pawnYCoordinate - 20}, "fast");
        }
      }

      // change pawn context
      $location.path(`/customer/${customerId}/pawns/${pawnId}`);
    };

    // https://stackoverflow.com/questions/487073/check-if-element-is-visible-after-scrolling
    function isScrolledIntoView(el) {
      let element = el[0];
      var elemTop = element.getBoundingClientRect().top;
      var elemBottom = element.getBoundingClientRect().bottom;

      return (elemTop >= 0) && (elemBottom <= window.innerHeight);
    }

    that.isSelectedPawnRegisteredBranch = (pawn) => {
      return pawn && this.contextBranchId === pawn.branchId;
    }

    that.isSelectedPawnRegisteredOrOriginalBranch = (pawn) => {
      return that.isSelectedPawnRegisteredBranch(pawn) || this.contextBranchId === pawn.originalBranchId;
    }

    that.showRATicketButton = (pawn) => {
      return !that.isSelectedPawnRegisteredBranch(pawn) && pawn.parentPawnId && this.showMessageOnPawnRenewalInAnotherBranch;
    }
  }
});
